"use client";

import { useMemo } from "react";
import { useSimBalance } from "@/hooks/useSimTokenInfo";

function formatUsdCompact(usd: number): string {
  if (usd >= 1_000_000) return `$${(usd / 1_000_000).toFixed(2)}M`;
  if (usd >= 1_000) return `$${(usd / 1_000).toFixed(2)}K`;
  if (usd >= 0.01) return `$${usd.toFixed(2)}`;
  if (usd > 0) return "< $0.01";
  return "$0.00";
}

export function WalletBalanceLabel({ address }: { address: string }) {
  const { data, isLoading } = useSimBalance(address);
  const totalUsd = useMemo(() => {
    if (!data?.balances) return 0;
    return data.balances.reduce((sum, b) => sum + (b.value_usd ?? 0), 0);
  }, [data]);

  if (isLoading) return <span className="text-ds-text-disabled text-xs">...</span>;
  return <span className="text-ds-text-muted text-xs">{formatUsdCompact(totalUsd)}</span>;
}
